import { BASE_PATH_RESOURCES, ANTEATER_URL } from 'constants/env';

export const NO_IMAGE = `${BASE_PATH_RESOURCES}/medios-plazavip/swift/v1/assets/img/noImage.png`;
export const TIMEOUT_TIME = 7000;
export const BASE_PATH_PORTAL = window.location.origin;
export const SEARCH_ANTEATER = `${ANTEATER_URL}/search`;
export const SEARCH_AUTOCOMPLETE = `${ANTEATER_URL}/autocompletar?cliente=sears`;
export const DOMAIN_CMS = 'https://cms.appsears.com';
export const API_KEY_CMS = '26367ca9803b0ed99e406bcea79ac2e68796e5c406475c51a35224c661051824';
